

import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import Btn from '../../components/shared/button/Btn'

import { showModal } from '../../features/modal/modalSlice'
import { useState } from 'react'
import { useEffect } from 'react'
import { getPersonalLoadOwners } from '../../features/isOrtaklari/isOrtaklariSlice'
import InputText from '../../components/shared/input/new/InputText'
import IsOrtaklariContainer from '../../components/isOrtaklariTable/IsOrtaklariContainer'
import useWindowDimensions from '../../hooks/useWindowSize'
import IsOrtaklariMobileContainer from '../../components/isOrtaklariTable/IsOrtaklariMobileContainer'

const Container = styled.div`
  width: 100%;
  cursor: pointer;

  .wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;

      .titles {
        width: 100%;
        margin-top: 30px;
        display: grid;
        grid-template-columns: repeat(4, 1fr); 
        padding-inline: 10px;
        gap: 15px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }

      .filter-container{
        width: 100%;
        height: auto;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0;
        gap: 10px;
        .input-container{
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .btn-container{
          width: 100%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 20px;
        }
      }
    }
  }

  @media (max-width: 850px){
    .filter-container{
      flex-direction: column;
      justify-content: flex-start !important;
      align-items: flex-start !important;
      .btn-container{
        justify-content: flex-start !important;
      }
    }
  }
`

const titles = ["Proje Adı", "Dijital Lojistikçi / Nakliyeci / Kooperatif", "Yükveren Müşteri", "Durum"]

const IsOrtaklari = () => {

    const {isOrtaklariList} = useSelector((state) => state.isOrtaklari)
    const dispatch = useDispatch()
    const [companyName, setCompanyName] = useState("")
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))

    const {windowDimensions} = useWindowDimensions()

    useEffect(() => {
      dispatch(getPersonalLoadOwners({companyName: companyName}))
    }, [companyName])
    
  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Projelerim"} position='sticky'/>
      <div className="content">
   
        <div className="filter-container">
          <div className="input-container">
            <InputText data={companyName} setData={(e) => setCompanyName(e.target.value)} labelText='Firma Adı' name={"companyName"} inputWidth={"200px"} />
          </div>
          <div className="btn-container">
          
            {rld !== ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228") &&
              <Btn bgColor={"transparent"} handleClick={() => dispatch(showModal("projeOlustur"))} color={"#E85446"} padding='0 10px' width='160px'>Proje Oluştur</Btn>
            }
          </div>
        </div>

        {windowDimensions?.width > 850 &&
          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>
        }
        
        {windowDimensions?.width < 850 ?
          isOrtaklariList?.map((item) => (
            <IsOrtaklariMobileContainer data={item} />
          ))
        :
          isOrtaklariList?.map((item) => (
            <IsOrtaklariContainer data={item} />
          ))
        }
      </div>
    </div>
  </Container>

  )
}

export default IsOrtaklari